import { Box, styled } from '@mui/material';
import { pxToRem } from '@themes';
var Container = styled(Box, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isDragActive';
  }
})(function (_ref) {
  var theme = _ref.theme,
      isDragActive = _ref.isDragActive;
  var styles = {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: pxToRem(24),
    borderWidth: pxToRem(2),
    borderRadius: pxToRem(14),
    borderColor: isDragActive ? theme.colors.funGreen : theme.colors.athensGray,
    borderStyle: 'dashed',
    backgroundColor: isDragActive ? theme.colors.gin : theme.colors.white,
    outline: 'none',
    transition: ' border .24s ease-in-out',
    cursor: 'pointer',
    width: '100%'
  };
  return styles;
});
export { Container };